import api from './api';

/**
 * A mike-goldberg v1 está em desativação: nenhuma chamada a ela pode
 * interromper login, refresh ou gravação de ações. Falha vira warn.
 */
export const registerScouterLegacy = async (
  name: string,
  token: string,
): Promise<void> => {
  try {
    await api.post('/scouters', { name, token });
  } catch (error) {
    console.warn('[legacy-mike] /scouters indisponível, seguindo sem ele', error);
  }
};
